// Qui peut jouer quelle histoire de « Situations ». La première est offerte (l'offre d'appel) ;
// les suivantes sont réservées à Believemy Pro. Même règle que Reps
// (lib/reps/access.js) : Pro ou Founder, rien pendant un impayé. Les
// administrateurs ouvrent tout, pour relire le contenu.
//
// La page et la route de l'API appellent toutes deux `canPlay` côté serveur :
// le badge sur la carte n'est qu'un affichage.

/** Le membre a-t-il Believemy Pro (ou Founder), paiement à jour ? */
export function hasPro(user) {
    if (!user) return false;
    if ((user.roles || []).some((role) => role === "ROLE_ADMIN" || role === "ROLE_SUPER_ADMIN")) return true;
    if (user.paymentPastDue) return false;
    return Boolean(user.pro || user.ultimate);
}

/** Le membre peut-il jouer cette histoire ? */
export const canPlay = (scenario, user) => scenario?.card?.access !== "pro" || hasPro(user);

/**
 * La rubrique « Situations » est-elle ouverte ? Réglé dans les deux blocs
 * `env` de next.config.mjs (NEXT_PUBLIC_STORIES_LIVE) : « 1 » en
 * développement, « 1 » en production une fois le back déployé avec sa table
 * client_story_progress. Le menu, la page, le plan du site, la route de
 * réaction et la sauvegarde suivent cette seule valeur (publique : le menu la
 * lit dans le navigateur).
 */
export const STORIES_LIVE = process.env.NEXT_PUBLIC_STORIES_LIVE === "1";
